<mat-card class="cardFirma" *ngIf="tableFirmaDataSource">
    <mat-card-header>
        <mat-card-title class="left">Firmenansicht</mat-card-title>
        <div class="toggle-deleted-elements">
            <mat-slide-toggle color="primary" 
                [checked]="showAlsoDeletedElements"
                (change)="updateResultList()">
                Auch gel&ouml;schte Standorte anzeigen
            </mat-slide-toggle>
        </div>
    </mat-card-header>
    <mat-card-content>
        <form class="tableFirmaForm" [formGroup]="editFirmaDatenForm">
            <table mat-table [dataSource]="tableFirmaDataSource" class="mat-elevation-z1">
                <ng-container matColumnDef="firmenname">
                    <th mat-header-cell *matHeaderCellDef> <b>FIRMA</b> </th>
                    <td mat-cell *matCellDef="let data"> {{data.firmenname}} </td>
                </ng-container>
                <ng-container matColumnDef="firmenId">
                    <th mat-header-cell *matHeaderCellDef> FIRMEN-ID </th>
                    <td mat-cell *matCellDef="let data"> {{data.firmenId}} </td>
                </ng-container>
                <ng-container matColumnDef="crefonummer">
                    <th mat-header-cell *matHeaderCellDef> CREFONUMMER </th>
                    <td mat-cell *matCellDef="let data">
                        {{data.crefonummer}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let data" class="text-right">
                        <button class="btn btn-flat btn-xs bg-gradient-primary ml-2 mt-n1" (click)="openEditFirmaDatenModal($event, data)">
                            Firmen-Daten &auml;ndern <i class="far fa-edit"></i>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedFirmaColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedFirmaColumns;"></tr>
            </table>
        </form>

        <table mat-table multiTemplateDataRows *ngIf="hauptstandortDataSource && hauptstandortDataSource.data.length > 0" [dataSource]="hauptstandortDataSource" class="mat-elevation-z1">
            <ng-container matColumnDef="hauptstandort">
                <th mat-header-cell *matHeaderCellDef> <b>HAUPTSTANDORT</b> <th>
                <td mat-cell [class.deleted-element]="element.istGeloescht == true" *matCellDef="let element">
                    <table style="width:100%">
                        <tr>
                            <td style="width:5%">
                                <button mat-icon-button color="primary"
                                        *ngIf="element.istGeloescht == false"
                                        (click)="toggleHauptstandortRow(element)">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{element == expandedHauptstandortElement ? 'remove' : 'add'}}
                                    </mat-icon>
                                </button>
                            </td>
                            <td style="width:49%">
                                {{element.strasseUndHausnummer ? element.strasseUndHausnummer + ', ' : '' }}
                                {{element.plz ? element.plz : '' }} {{element.ort ? element.ort : '' }}
                                {{element.laendercode ? '(' + element.laendercode + ')' : '' }}
                            </td>
                            <td>
                                {{element.beDirectId ? 'BeDirect-ID ' + element.beDirectId + ' | ' : '' }}
                                {{element.firmenstandortId ? 'FirmenstandorteId ' + element.firmenstandortId : '' }}
                            </td>
                        </tr>
                    </table>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="text-right">
                    <button class="btn btn-flat btn-xs bg-gradient-primary" [disabled]="element.istGeloescht == true" *ngFor="let action of element.actions" (click)="this.action.functionCall.apply(this, [$event, element])">
                        {{action.label}} <i class="far fa-edit"></i>
                    </button>
                    <button class="btn btn-flat btn-xs bg-gradient-secondary ml-2" (click)="toggleTransactionsRow(element, $event)">
                        <i class="fas fa-database"></i> <i class="fas fa-history ml-1"></i>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedHistory">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedFirmenstandortColumns.length">
                    <div class="element-history" *ngIf="element.transactions?.length"
                        [@expandableRow]="element.transactions && element.transactions.length > 0 ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1">
                            <table #innerTables mat-table [dataSource]="element.transactions">
                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef> DATUM </th>
                                    <td mat-cell *matCellDef="let element"> {{element.datum | date:'dd.MM.yyyy'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="uhrzeit">
                                    <th mat-header-cell *matHeaderCellDef> UHRZEIT </th>
                                    <td mat-cell *matCellDef="let element"> {{element.uhrzeit | date:'hh:mm:ss'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="transactionId">
                                    <th mat-header-cell *matHeaderCellDef> TRANSAKTION-ID </th>
                                    <td mat-cell *matCellDef="let element"> {{element.transactionId}} </td>
                                </ng-container>

                                <ng-container matColumnDef="user">
                                    <th mat-header-cell *matHeaderCellDef> USER </th>
                                    <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                                </ng-container>

                                <ng-container matColumnDef="aktion">
                                    <th mat-header-cell *matHeaderCellDef> AKTION </th>
                                    <td mat-cell *matCellDef="let element" class="action-description" [innerHTML]="element.aktion | nl2br"></td>
                                </ng-container>

                                <ng-container matColumnDef="kommentar">
                                    <th mat-header-cell *matHeaderCellDef> KOMMENTAR </th>
                                    <td mat-cell *matCellDef="let element" class="action-description"> {{element.kommentar}} </td>
                                </ng-container>

                                <ng-container matColumnDef="footer">
                                    <td mat-footer-cell *matFooterCellDef class="text-right">
                                        <button class="btn btn-flat btn-xs bg-gradient-secondary mt-2 mb-1" (click)="seeCompleteHistory(element)">
                                            Gesamte Historie ansehen <i class="fas fa-database"></i> <i class="fas fa-history ml-1"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns;"
                                    [class.element-row]="row.transactions ? row.transactions.length : 0"></tr>
                                <tr mat-footer-row *matFooterRowDef="['footer']" class="history-footer"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container> 

            <ng-container matColumnDef="expandedPcAdressen">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedFirmenstandortColumns.length + 1">
                    <div class="element-pcadressen" *ngIf="element.pcAdressen?.length"
                        [@expandableRow]="element == expandedHauptstandortElement ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1" *ngIf="element == expandedHauptstandortElement">
                            <table #innerTableshauptstandort mat-table [dataSource]="element.pcAdressen">
                                <ng-container matColumnDef="{{innerColumn.name}}" *ngFor="let innerColumn of initColumns">
                                    <th mat-header-cell *matHeaderCellDef> {{innerColumn.label.toUpperCase()}} </th>
                                    <td mat-cell [class.deleted-element]="element.istGeloescht == true" *matCellDef="let element"> {{element[innerColumn.name]}} </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" class="text-right">
                                        <button class="btn btn-flat btn-xs bg-gradient-primary ml-3" *ngFor="let action of element.actions" (click)="this.action.functionCall.apply(this, [$event, element])">
                                            {{action.label}} <i class="fas fa-exchange-alt"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedPcAdresseColumnsWithActions"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedPcAdresseColumnsWithActions;"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedHauptstandortColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedHauptstandortColumns;"
                [class.element-row]="row.pcAdressen.length"
                [class.expanded-row]="expandedHauptstandortElement == row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedHistory'];" class="history-row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedPcAdressen'];" class="pcadressen-row mt-4"></tr>
        </table>
    </mat-card-content>
</mat-card>

<mat-card class="cardAndereFirmenstandorte mt-3" *ngIf="firmenstandortDataSource && firmenstandortDataSource.data.length > 0">
    <mat-card-content>
        <table mat-table multiTemplateDataRows [dataSource]="firmenstandortDataSource" class="mat-elevation-z1">
            <ng-container matColumnDef="standort">
                <th mat-header-cell *matHeaderCellDef> <b>WEITERE STANDORTE</b> <th>
                <td mat-cell [class.deleted-element]="element.istGeloescht == true" *matCellDef="let element">
                    <table style="width:100%">
                        <tr>
                            <td style="width:5%">
                                <button mat-icon-button color="primary"
                                        *ngIf="element.istGeloescht == false"
                                        (click)="toggleRow(element)">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{element == expandedElement ? 'remove' : 'add'}}
                                    </mat-icon>
                                </button>
                            </td>
                            <td style="width:49%">
                                {{element.strasseUndHausnummer ? element.strasseUndHausnummer + ', ' : '' }}
                                {{element.plz ? element.plz : '' }} {{element.ort ? element.ort : '' }}
                                {{element.laendercode ? '(' + element.laendercode + ')' : '' }}
                            </td>
                            <td>
                                {{element.beDirectId ? 'BeDirect-ID ' + element.beDirectId + ' | ' : '' }}
                                {{element.firmenstandortId ? 'FirmenstandorteId ' + element.firmenstandortId : '' }}
                            </td>
                        </tr>
                    </table>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="text-right">
                    <ng-container *ngFor="let action of element.actions">
                        <button class="btn btn-flat btn-xs {{action.styleClass}} ml-2" [disabled]="element.istGeloescht == true" (click)="this.action.functionCall.apply(this, [$event, element])">
                            {{action.label}} <i class="{{action.iconClass}}"></i>
                        </button>
                    </ng-container>
                    <button class="btn btn-flat btn-xs bg-gradient-secondary ml-2" (click)="toggleTransactionsRow(element, $event)">
                        <i class="fas fa-database"></i> <i class="fas fa-history ml-1"></i>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedHistory">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedFirmenstandortColumns.length">
                    <div class="element-history" *ngIf="element.transactions?.length"
                        [@expandableRow]="element.transactions && element.transactions.length > 0 ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1">
                            <table #innerTables mat-table [dataSource]="element.transactions">
                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef> DATUM </th>
                                    <td mat-cell *matCellDef="let element"> {{element.datum | date:'dd.MM.yyyy'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="uhrzeit">
                                    <th mat-header-cell *matHeaderCellDef> UHRZEIT </th>
                                    <td mat-cell *matCellDef="let element"> {{element.uhrzeit | date:'hh:mm:ss'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="transactionId">
                                    <th mat-header-cell *matHeaderCellDef> TRANSACTION-ID </th>
                                    <td mat-cell *matCellDef="let element"> {{element.transactionId}} </td>
                                </ng-container>

                                <ng-container matColumnDef="user">
                                    <th mat-header-cell *matHeaderCellDef> USER </th>
                                    <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                                </ng-container>

                                <ng-container matColumnDef="aktion">
                                    <th mat-header-cell *matHeaderCellDef> AKTION </th>
                                    <td mat-cell *matCellDef="let element" [innerHTML]="element.aktion | nl2br"></td>
                                </ng-container>

                                <ng-container matColumnDef="kommentar">
                                    <th mat-header-cell *matHeaderCellDef> KOMMENTAR </th>
                                    <td mat-cell *matCellDef="let element"> {{element.kommentar}} </td>
                                </ng-container>

                                <ng-container matColumnDef="footer">
                                    <td mat-footer-cell *matFooterCellDef [attr.colspan]="2">
                                        <button class="btn btn-flat btn-xs bg-gradient-secondary mt-2" (click)="seeCompleteHistory(element)">
                                            Gesamte Historie ansehen <i class="fas fa-database"></i> <i class="fas fa-history ml-1"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns;"
                                [class.element-row]="row.transactions ? row.transactions.length : 0"></tr>
                                <tr mat-footer-row *matFooterRowDef="['footer']" class="history-footer"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container> 

            <ng-container matColumnDef="expandedPcAdressen">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedFirmenstandortColumns.length + 1">
                    <div class="element-pcadressen" *ngIf="element.pcAdressen?.length"
                        [@expandableRow]="element == expandedElement ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1" *ngIf="element == expandedElement">
                            <table #innerTables mat-table [dataSource]="element.pcAdressen">
                                <ng-container matColumnDef="{{innerColumn.name}}" *ngFor="let innerColumn of initColumns">
                                    <th mat-header-cell *matHeaderCellDef> {{innerColumn.label.toUpperCase()}} </th>
                                    <td mat-cell [class.deleted-element]="element.istGeloescht == true" *matCellDef="let element"> {{element[innerColumn.name]}} </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" class="text-right">
                                        <button class="btn btn-flat btn-xs bg-gradient-primary ml-3" [disabled]="element.istGeloescht == true" *ngFor="let action of element.actions" (click)="this.action.functionCall.apply(this, [$event, element])">
                                            {{action.label}} <i class="fas fa-exchange-alt"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedPcAdresseColumnsWithActions"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedPcAdresseColumnsWithActions;"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedFirmenstandortColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedFirmenstandortColumns;"
                [class.element-row]="row.pcAdressen.length"
                [class.expanded-row]="expandedElement == row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedHistory'];" class="history-row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedPcAdressen'];" class="pcadressen-row mt-4"></tr>
        </table>
    </mat-card-content>
</mat-card>

<mat-card class="card-actions mt-4">
    <mat-card-content>
        <div class="back-btn">
            <button (click)="back()" class="btn btn-flat bg-gradient-secondary left">
                <i class="fas fa-arrow-left"></i> Zur&uuml;ck zur Liste
            </button>
        </div>
    </mat-card-content>
</mat-card>

<div class="modal fade" id="modalEditFirmaDaten" tabindex="-1" role="dialog" aria-labelledby="modalEditFirmaDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">Firmen-Daten bearbeiten</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="editFirmaDatenForm" class="edit-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="editFirmaDaten()">
                    <h5>Firma</h5>
                    <div class="row d-flex">
                        <div class="col-8">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Firmenname</mat-label>
                                <input matInput formControlName="firmenname">
                            </mat-form-field>
                        </div>
                    </div>
                    <p class="small text-muted">Die folgenden Felder k&ouml;nnen nicht ge&auml;ndert werden.</p>
                    <div class="row d-flex">
                        <div class="col-4">
                            <mat-form-field color="primary" appearance="outline" class="responsive_input readonly">
                                <mat-label>Branchenzuschlag</mat-label>
                                <input matInput formControlName="branchenzuschlag" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>BranchencodeWz1979</mat-label>
                                <input matInput formControlName="branchencodeWz1979" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>BranchencodeWz2008</mat-label>
                                <input matInput formControlName="branchencodeWz2008" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-5">
                            <mat-form-field color="primary" appearance="outline" class="responsive_input readonly">
                                <mat-label>Lieferant</mat-label>
                                <input matInput formControlName="lieferantVonBranche" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>W&auml;hrung</mat-label>
                                <input matInput formControlName="waehrungscode" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-5">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>Webseite/Homepage</mat-label>
                                <input matInput formControlName="webseiteHomepage" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closeEditFirmaDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="editFirmaDaten()"
                        [disabled]="editFirmaDatenForm.touched && editFirmaDatenForm.status !== 'VALID' || editFirmaDatenForm.errors">
                    Firmen-Daten speichern <i class="fa fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalEditStandortDaten" tabindex="-1" role="dialog" aria-labelledby="modalEditStandortDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 *ngIf="currentStandortIsHauptstandort else elseBlockMt" class="modal-title">Hauptstandort bearbeiten</h5>
                <ng-template #elseBlockMt>
                    <h5 class="modal-title">Standort bearbeiten</h5>
                </ng-template>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="editStandortDatenForm" class="edit-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="editStandortDaten()">
                    <h5 *ngIf="currentStandortIsHauptstandort else elseBlock">Hauptstandort</h5>
                    <ng-template #elseBlock>
                        <h5>Standort</h5>
                    </ng-template>
                    <div class="row">
                        <div class="col-10">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Straße</mat-label>
                                <input matInput formControlName="strasseUndHausnummer">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>PLZ</mat-label>
                                <input matInput formControlName="plz">
                            </mat-form-field>
                        </div>
                        <div class="col-7">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Ort</mat-label>
                                <input matInput formControlName="ort">
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Land (Code)</mat-label>
                                <input matInput formControlName="laendercode">
                            </mat-form-field>
                        </div>
                    </div>
                    <p class="small text-muted">Die folgenden Felder k&ouml;nnen nicht ge&auml;ndert werden.</p>
                    <div class="row">
                        <div class="col-4">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>Telefon</mat-label>
                                <input matInput formControlName="telefon" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>Telefax</mat-label>
                                <input matInput formControlName="fax" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field appearance="outline" class="responsive_input readonly">
                                <mat-label>E-Mail</mat-label>
                                <input matInput formControlName="email" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <mat-form-field color="primary" appearance="outline" class="responsive_input readonly">
                                <mat-label>Betriebsgr&ouml;&szlig;e</mat-label>
                                <input matInput formControlName="betriebsgroesse" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field color="primary" appearance="outline" class="responsive_input readonly">
                                <mat-label>BG gewerblich</mat-label>
                                <input matInput formControlName="betriebsgroesseGewerblich" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field color="primary" appearance="outline" class="responsive_input readonly">
                                <mat-label>BG kaufm&auml;nnisch</mat-label>
                                <input matInput formControlName="betriebsgroesseKaufmaennisch" class="readonly" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closeEditStandortDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="editStandortDaten()"
                        [disabled]="editStandortDatenForm.touched && editStandortDatenForm.status !== 'VALID' || editStandortDatenForm.errors">
                    Standort-Daten speichern <i class="fa fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modalSelectPcAdresseZuordnen" tabindex="-1" role="dialog" aria-labelledby="modalSelectPcAdresseZuordnenLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">PC-Adresse neu zuordnen</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Wohin soll die PC-Adresse<br/><br/>
                <b>
                    <span *ngIf="currentPcAdresse?.pcAdressnummer">PC-Adr.-Nr. {{ currentPcAdresse?.pcAdressnummer }} </span>
                    <span *ngIf="currentPcAdresse?.nlCode">(NL {{ currentPcAdresse?.nlCode }})</span>
                    <br *ngIf="currentPcAdresse?.pcAdressnummer || currentPcAdresse?.nlCode"/>
                    <span *ngIf="currentPcAdresse?.originalFirmenname">{{ currentPcAdresse?.originalFirmenname }}<br/></span>
                    {{ currentPcAdresse?.strasseUndHausnummer }}, {{ currentPcAdresse?.plz }} {{ currentPcAdresse?.ort }} ({{ currentPcAdresse?.laendercode }})</b>
                <br/><br/>
                verschoben werden?</p>

                <div class="row d-flex justify-content-center mb-3">
                    <div class="col-4">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <button class="btn bg-gradient-primary btn-flat" (click)="selectPcAdresseZuordnen('neue_firma')" style="min-width: 153px;">
                                    Neue Firma <i class="fa fa-fw fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <button [matMenuTriggerFor]="pcAdrGleicheFirmaOptions" class="btn bg-gradient-primary btn-flat dropdown-toggle">
                                    Gleiche Firma <i class="fa fa-fw fa-exchange-alt"></i>
                                </button>
                                <mat-menu #pcAdrGleicheFirmaOptions="matMenu">
                                    <button mat-menu-item (click)="selectPcAdresseZuordnen('gleiche_firma', 'neuer_standort')">neuer Standort</button>
                                    <button mat-menu-item [disabled]="firmenStandorte.length<=1" (click)="selectPcAdresseZuordnen('gleiche_firma', 'vorhandener_standort')">vorhandener Standort</button>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 text-right">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <button [matMenuTriggerFor]="anotherFirmaOptions" class="btn bg-gradient-primary btn-flat dropdown-toggle">
                                    Andere Firma <i class="fas fa-fw fa-external-link-alt"></i>
                                </button>
                                <mat-menu #anotherFirmaOptions="matMenu">
                                    <button mat-menu-item (click)="selectPcAdresseZuordnen('andere_firma', 'neuer_standort')">neuer Standort</button>
                                    <button mat-menu-item (click)="selectPcAdresseZuordnen('andere_firma', 'vorhandener_standort')">vorhandener Standort</button>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closePcAdresseZuordnenModal()">
                    Abbrechen <i class="fas fa-fw fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPcAdrNeueFirmaDaten" tabindex="-1" role="dialog" aria-labelledby="modalPcAdrNeueFirmaDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">PC-Adresse einem neuen Standort einer neuen Firma zuordnen</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="pcAdrNeueFirmaDatenForm" class="edit-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="pcAdrNeueFirmaDaten()">
                    <h5>Firma</h5>
                    <div class="row d-flex">
                        <div class="col-10">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Firmenname</mat-label>
                                <input matInput formControlName="firmenname">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Straße</mat-label>
                                <input matInput formControlName="strasseUndHausnummer">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>PLZ</mat-label>
                                <input matInput formControlName="plz">
                            </mat-form-field>
                        </div>
                        <div class="col-7">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Ort</mat-label>
                                <input matInput formControlName="ort">
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Land (Code)</mat-label>
                                <input matInput formControlName="laendercode">
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closePcAdrNeueFirmaDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="pcAdrNeueFirmaDaten()"
                        [disabled]="pcAdrNeueFirmaDatenForm.touched && pcAdrNeueFirmaDatenForm.status !== 'VALID' || pcAdrNeueFirmaDatenForm.errors">
                    Neue Firma anlegen <i class="fa fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPcAdrNeuerStandortDaten" tabindex="-1" role="dialog" aria-labelledby="modalPcAdrNeuerStandortDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">PC-Adresse einem neuen Standort zuordnen
                    (<span *ngIf="pcAdrMode==='andere Firma'">andere Firma</span>
                    <span *ngIf="pcAdrMode==='gleiche Firma'">gleiche Firma</span>)</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="pcAdrNeuerStandortDatenForm" class="edit-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="savePcAdrNeuerStandortDaten()">
                    <div class="row">
                        <div class="col-10">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Straße</mat-label>
                                <input matInput formControlName="strasseUndHausnummer">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>PLZ</mat-label>
                                <input matInput formControlName="plz">
                            </mat-form-field>
                        </div>
                        <div class="col-7">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Ort</mat-label>
                                <input matInput formControlName="ort">
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Land (Code)</mat-label>
                                <input matInput formControlName="laendercode">
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closePcAdrNeuerStandortDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="savePcAdrNeuerStandortDaten()"
                        [disabled]="pcAdrNeuerStandortDatenForm.touched && pcAdrNeuerStandortDatenForm.status !== 'VALID' || pcAdrNeuerStandortDatenForm.errors">
                    Neuen Standort anlegen <i class="fa fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPcAdrVorhandenerStandortDaten" tabindex="-1" role="dialog" aria-labelledby="modalPcAdrVorhandenerStandortDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">PC-Adresse einem vorhandenen Standort
                    <span *ngIf="pcAdrMode==='andere Firma'">einer anderen </span>
                    <span *ngIf="pcAdrMode==='gleiche Firma'">der gleichen </span>
                    Firma zuordnen</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div id="vorhandenerStandort" class="firmenstandorte-results-container">
                    <div class="table-container mb-2" *ngIf="pcAdrVorhandeneStandorteListLength>0">
                        <table mat-table [dataSource]="pcAdrVorhandeneStandorteDataSource" class="mat-elevation-z1 andere-firma-table">
                            <ng-container matColumnDef="strasseUndHausnummer">
                                <th mat-header-cell *matHeaderCellDef> STRASSE </th>
                                <td mat-cell *matCellDef="let data"> {{data.strasseUndHausnummer}} </td>
                            </ng-container>
                            <ng-container matColumnDef="plz">
                                <th mat-header-cell *matHeaderCellDef> PLZ </th>
                                <td mat-cell *matCellDef="let data"> {{data.plz}} </td>
                            </ng-container>
                            <ng-container matColumnDef="ort">
                                <th mat-header-cell *matHeaderCellDef> ORT </th>
                                <td mat-cell *matCellDef="let data"> {{data.ort}} </td>
                            </ng-container>
                            <ng-container matColumnDef="beDirectId">
                                <th mat-header-cell *matHeaderCellDef> BEDIRECT-ID </th>
                                <td mat-cell *matCellDef="let data"> {{data.beDirectId}} </td>
                            </ng-container>
                            <ng-container matColumnDef="pcAdrVorhandenerStandortSelected">
                                <th mat-header-cell *matHeaderCellDef> </th>
                                <td mat-cell *matCellDef="let data">
                                    <mat-radio-button color="primary" name="selectPcAdrVorhandenerStandort" (click)="selectPcAdrVorhandenerStandort(data)">

                                    </mat-radio-button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedPcAdrVorhandeneStandorteColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedPcAdrVorhandeneStandorteColumns;"></tr>
                        </table>
                    </div>
                    <div class="paginator-container">
                        <mat-paginator #paginator
                           [hidden]="pcAdrVorhandeneStandorteListLength<=5"
                           [length]="pcAdrVorhandeneStandorteListLength"
                           [showFirstLastButtons]="true"
                           [pageSize]="5">
                        </mat-paginator>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closePcAdrVorhandenerStandortDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="savePcAdrVorhandenerStandortDaten()"
                        [disabled]="!currentSelectedStandort">
                    PC-Adresse zuordnen <i class="fa fa-check"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPcAdrAndereFirmaDaten" tabindex="-1" role="dialog" aria-labelledby="modalPcAdrVorhandenerStandortDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">PC-Adresse einem
                    <span *ngIf="pcAdrStandortMode==='neu'">neuen</span>
                    <span *ngIf="pcAdrStandortMode==='vorhanden'">vorhandenen</span>
                    Standort einer anderen Firma zuordnen</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <h5>Firma suchen</h5>
                <form class="container" [formGroup]="pcAdrAndereFirmaSuchForm">
                    <div class="row d-flex firmenname-search">
                        <div class="col-5">
                            <mat-form-field class="input-search mr-3">
                                <mat-label>Firmenname eingeben</mat-label>
                                <input matInput formControlName="searchFirmenname">
                            </mat-form-field>
                        </div>
                        <div class="col-1 pt-4">
                            oder
                        </div>
                        <div class="col-5">
                            <mat-form-field class="input-search">
                                <mat-label>Firmen-ID eingeben</mat-label>
                                <input matInput formControlName="searchFirmenId">
                            </mat-form-field>
                        </div>
                        <div class="col-1 pt-2">
                            <button type="submit" class="btn btn-flat btn-primary button-search" (click)="getPcAdrAndereFirmen(0);">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </form>
                <div id="andere_firma_results" class="andere-firma-results-container mt-3">
                    <div class="table-container mb-2" *ngIf="pcAdrAndereFirmaResultListLength>0">
                        <table mat-table [dataSource]="pcAdrAndereFirmaDataSource" class="mat-elevation-z1 andere-firma-table">
                            <ng-container matColumnDef="firmenname">
                                <th mat-header-cell *matHeaderCellDef> NAME </th>
                                <td mat-cell *matCellDef="let data">{{data.firmenname}}</td>
                            </ng-container>
                            <ng-container matColumnDef="strasseUndHausnummer">
                                <th mat-header-cell *matHeaderCellDef> STRASSE </th>
                                <td mat-cell *matCellDef="let data"> {{data.strasseUndHausnummer}} </td>
                            </ng-container>
                            <ng-container matColumnDef="plz">
                                <th mat-header-cell *matHeaderCellDef> PLZ </th>
                                <td mat-cell *matCellDef="let data"> {{data.plz}} </td>
                            </ng-container>
                            <ng-container matColumnDef="ort">
                                <th mat-header-cell *matHeaderCellDef> ORT </th>
                                <td mat-cell *matCellDef="let data"> {{data.ort}} </td>
                            </ng-container>
                            <ng-container matColumnDef="firmenId">
                                <th mat-header-cell *matHeaderCellDef> FIRMEN-ID </th>
                                <td mat-cell *matCellDef="let data"> {{data.firmenId}} </td>
                            </ng-container>
                            <ng-container matColumnDef="pcAdrAndereFirmaSelected">
                                <th mat-header-cell *matHeaderCellDef> </th>
                                <td mat-cell *matCellDef="let data">
                                    <mat-radio-button color="primary" name="pcAdrAndereFirmaSelected" (click)="selectPcAdrAndereFirma(data)"></mat-radio-button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="pcAdrDisplayedAndereFirmaColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: pcAdrDisplayedAndereFirmaColumns;"></tr>
                        </table>
                    </div>
                    <div class="paginator-container">
                        <mat-paginator
                            [hidden]="pcAdrAndereFirmaResultListLength<=5"
                            (page)="getPcAdrAndereFirmenPageData($event)"
                            [length]="pcAdrAndereFirmaResultListLength"
                            [pageSize]="pcAdrAndereFirmaPageSize"
                            [showFirstLastButtons]="true">
                        </mat-paginator>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closePcAdrAndereFirmaDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button *ngIf="pcAdrStandortMode==='vorhanden'" class="btn bg-gradient-secondary btn-flat"
                        (click)="closePcAdrAndereFirmaDatenModal();openPcAdrVorhandenerStandortDatenModal();"
                        [disabled]="!this.currentSelectedFirmenId">
                    Standort ausw&auml;hlen <i class="fa fa-arrow-right"></i>
                </button>
                <button *ngIf="pcAdrStandortMode==='neu'" class="btn bg-gradient-success btn-flat"
                        (click)="closePcAdrAndereFirmaDatenModal();openPcAdrNeuerStandortDatenModal();"
                        [disabled]="!this.currentSelectedFirmenId">
                    Neuen Standort erstellen <i class="fa fa-asterisk"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="modalSuccess" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content bg-gradient-success-modal">
            <div class="modal-header">
                <h4 class="modal-title">Erfolg!</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ successMsg }}</p>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-flat btn-outline-light" (click)="closeSuccessModal()">
                    Schlie&szlig;en <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="modalError" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content bg-gradient-danger-modal">
            <div class="modal-header">
                <h4 class="modal-title">Fehler!</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body" [innerHTML]="errorMsg"></div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-flat btn-outline-light" (click)="closeErrorModal()">
                    Schlie&szlig;en <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</div>

